import * as z from 'zod';

export const userSchema = z.object({
  firstName: z
    .string()
    .regex(/^[A-Za-z]+$/, {
      message: 'Must contain only alphabets. No spaces.',
    })
    .min(2, { message: 'Enter a name' })
    .max(50, { message: 'Maximum length: 50 characters' }),

  lastName: z
    .string()
    .regex(/^[A-Za-z]+$/, {
      message: 'Must contain only alphabets. No spaces.',
    })
    .min(2, { message: 'Last name must be at least 2 characters' })
    .max(50, { message: 'Maximum length: 50 characters' }),

  phone_number: z
    .string()
    .regex(/^\d{10}$/, { message: 'Phone number must be 10 digits' }),

  personalEmail: z
    .string()
    .email({ message: 'Enter valid email format (e.g., example@domain.com)' }),

  fluentEmail: z
    .string()
    .email({
      message:
        'Must be a valid email format and end with `@fluentinhealth.com`',
    })
    .regex(/@(fluentinhealth\.com|qa\.fluentinhealth\.com)$/, {
      message: 'Email must end with @fluentinhealth.com or @qa.fluentinhealth.com',
    })
    .max(50, { message: 'Maximum length: 50 characters' }),

  roles: z
    .array(z.string())
    .min(1, { message: 'At least one role must be selected' }),
});

export type UserFormInputs = z.infer<typeof userSchema>;

export const DEFAULT_ADD_USER_SCHEMA_VALUES: UserFormInputs = {
  firstName: '',
  lastName: '',
  phone_number: '',
  personalEmail: '',
  fluentEmail: '',
  roles: [],
};
